import React from "react";

// 🔹 Bild-Imports
import imgUmzug from "../bilder/service-umzug.png";
import imgMontage from "../bilder/service-moebelmontage.png";
import imgDemontage from "../bilder/service-demontage.png";
import imgTransport from "../bilder/service-transporter.jpg";
import imgSchnell from "../bilder/service-schnell.png";
import imgSicher from "../bilder/service-versicherung.png";
import imgPreiswert from "../bilder/service-preiswert.png";
import imgEntsorgung from "../bilder/service-entsorgung.jpg"
import imgPunkte from "../bilder/service-punkt.png"
// 🔹 Datenarray mit Bild-Objekten
const services = [
  {
    key: "umzug",
    title: "Helfer mit Transporter",
    text: "Transporter – inkl. An-/Abfahrt & Versicherung",
    emoji: "🚚",
    img: imgUmzug,
    alt: "Umzugshelfer tragen Kartons aus einem Transporter in ein Wohnhaus.",
  },
  {
    key: "helfer-ohne",
    title: "Helfer ohne Transporter",
    text: "Tragehelfer ab 2 Stunden buchbar",
    emoji: "📦",
    img: imgDemontage,
    alt: "Zwei Umzugshelfer heben Möbelstücke und Kartons.",
  },

  {
    key: "montage",
    title: "Möbel-Montage",
    text: "Auf- und Abbau, Küche, Schränke",
    emoji: "🛠️",
    img: imgMontage,
    alt: "Monteur baut einen Kleiderschrank zusammen.",
  },
  {
    key: "versicherung",
    title: "Versicherung",
    text: "Auf Wunsch können wir Ihr Umzugsgut über eine Versicherung absichern.",
    emoji: "🛡️",
    img: imgSicher,
    alt: "Umzugsgut wird sorgfältig verpackt und geschützt.",
  },
  {
    key: "kurzfristig",
    title: "Kurzfristig",
    text: "Schnelle Verfügbarkeit – auch morgen",
    emoji: "⏱️",
    img: imgSchnell,
    alt: "Transporter fährt durch die Stadt mit Bewegungsunschärfe.",
  },
  {
    key: "preiswert",
    title: "Preiswert",
    text: "Faire Preise & zufriedene Kunden",
    emoji: "💶",
    img: imgPreiswert,
    alt: "Glückliches Paar freut sich in neuer Wohnung nach dem Umzug.",
  },
  {
  key: "entsorgung",
  title: "Entsorgung",
  text: "Fachgerechte Entsorgung von alten Möbeln, Sperrmüll und Verpackungsmaterialien auf Wunsch.",
  emoji: "♻️",
  img: imgEntsorgung, // entsprechendes Bild einfügen
  alt: "Entsorgung von alten Möbeln und Sperrmüll nach dem Umzug.",
},
{
  key: "punktesystem",
  title: "Arbeiten nach Punktesystem",
  text: "Möbel und Kartons werden direkt in die von Ihnen gewünschten Zimmer geladen (z. B. nach Markierungen oder Punkten).",
  emoji: "📍",
  img: imgPunkte, // entsprechendes Bild einfügen
  alt: "Umzugshelfer stellen Kartons gezielt in die richtigen Zimmer.",
},

];

export default function Services() {
  return (
    <section id="services" className="py-12 md:py-16 bg-white">
      <div className="max-w-[1100px] mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold">Leistungen</h2>

        <div className="mt-6 grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {services.map((s) => (
            <article
              key={s.key}
              className="group rounded-2xl overflow-hidden shadow-[0_10px_25px_rgba(2,6,23,.06)] bg-white"
            >
              {/* 🔹 Bild */}
              <div className="relative">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  decoding="async"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60 group-hover:opacity-30 transition-opacity" />
              </div>

              {/* 🔹 Text */}
              <div className="p-5">
                <div className="font-semibold text-brand flex items-center gap-2">
                  <span>{s.emoji}</span>
                  <span>{s.title}</span>
                </div>
                <p className="text-sm text-slate-600 mt-2">{s.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
